import {
  IWorkspaceCountersAction,
  IWorkspaceCountersState,
  WorkspaceCountersTypes
} from '@redux/types/workspaceCountersType';

const INITIAL_STATE: IWorkspaceCountersState = {
  allTasks: {
    count: 0,
    campaignGroupsCount: 0,
    taskBoardGroupsCount: 0
  },
  myTasks: {
    count: 0,
    campaignGroupsCount: 0,
    taskBoardGroupsCount: 0
  },
  assignedToMeTasks: {
    count: 0,
    campaignGroupsCount: 0,
    taskBoardGroupsCount: 0
  },
  deletedTasks: {
    count: 0,
    campaignGroupsCount: 0,
    taskBoardGroupsCount: 0
  }
};

const workspaceCountersReducer = (
  state = INITIAL_STATE,
  action: IWorkspaceCountersAction
): IWorkspaceCountersState => {
  switch (action.type) {
    case WorkspaceCountersTypes.SET_WORKSPACE_COUNTERS: {
      return action.payload;
    }
    case WorkspaceCountersTypes.UPDATE_WORKSPACE_COUNTERS: {
      const { entity, count, isTaskCounter } = action.payload;
      if (isTaskCounter) {
        return {
          ...state,
          [entity]: { count }
        };
      }
      return {
        ...state,
        [entity]: count
      };
    }
    default: {
      return state;
    }
  }
};

export default workspaceCountersReducer;
